import { useState } from "react"
import { GET_INVITATIONS_EMAIL_SELECTOR } from "@graphql"
import { getGraphQLErrorMessage } from "@helpers"
import { useLazyQuery } from "@apollo/client"
import { orderBy } from "lodash"

const useInvitationsLoader = ({ eventId, notify }) => {
  const [invitations, setInvitations] = useState([])
  const [invitationSelections, setInvitationSelections] = useState([])
  const [filter, setFilter] = useState("INVITATION_EMAIL_NEVER_SENT")
  const [searchTerm, setSearchTerm] = useState("")
  const [selectedGroupIds, setSelectedGroupIds] = useState([])
  const [page, setPage] = useState(1)
  const [perPage] = useState(50)

  const [getInvitations] = useLazyQuery(GET_INVITATIONS_EMAIL_SELECTOR, {
    fetchPolicy: "no-cache",
    onError: (errors) => notify({ title: "Error", type: "danger", content: getGraphQLErrorMessage(errors, "An error occurred while fetching invitations."), open: true }),
  })

  const loadInvitations = async (newFilter = null, newSearchTerm = null, newGroupIds = null, newPage, excludeQueued = true, merge = false) => {
    if (newFilter) setFilter(newFilter)
    if (newSearchTerm !== null) setSearchTerm(newSearchTerm)
    if (newPage) setPage(newPage)
    if (newGroupIds) setSelectedGroupIds(newGroupIds)

    const { data } = await getInvitations({
      variables: {
        input: {
          event_id: eventId,
          filter: newFilter || filter,
          group_ids: newGroupIds || selectedGroupIds,
          search_term: newSearchTerm !== null ? newSearchTerm : searchTerm,
          exclude_queued: excludeQueued
        },
        page: newPage || page,
        perPage,
      },
    })

    const newInvitations = data?.invitationsEmailSelector?.data || []

    if (merge) {
      const newIds = newInvitations.map((i) => i.id)
      const filteredOld = invitations.filter((i) => !newIds.includes(i.id))
      setInvitations(orderBy([...filteredOld, ...newInvitations], ["students"], ["asc"]))
    } else {
      setInvitations(newInvitations)
    }

    if (newFilter) {
      const emailIds = data?.invitationsEmailSelectorIds || []
      setInvitationSelections(emailIds.map((emailIds) => ({ ...emailIds, selected: true })))
    }
  }

  return {
    invitations,
    invitationSelections,
    filter,
    setFilter,
    searchTerm,
    selectedGroupIds,
    setSearchTerm,
    setSelectedGroupIds,
    page,
    setInvitationSelections,
    setPage,
    loadInvitations,
  }
}

export default useInvitationsLoader